<template>
	<v-card
  rounded='xl'
		class="pa-6 glass-card mx-auto"
		max-width="1000"
		elevation="6"
	>
		<v-card-title class="d-flex align-center pa-0 mb-4">
			<v-icon
				icon="$mdiChartTimelineVariantShimmer"
				color="cyan accent-3"
				class="mr-3"
			></v-icon>
			<span class="text-h5 font-weight-bold">Toma el control con Datos en Tiempo Real</span>
		</v-card-title>

		<v-card-text class="text-h6 pa-0 mb-4">
			Transforma la data de todas tus áreas en dashboards accionables para una planificación y gestión sin igual.
		</v-card-text>

		<v-card-actions class="pa-0" style="width: fit-content;">
			<v-icon
				icon="$mdiStarFourPointsOutline"
				color="yellow accent-4"
				class="mr-2"
			></v-icon>
			<span class="font-weight-medium">Genera Ideas Estratégicas con IA y Análisis de Datos</span>
		</v-card-actions>
		<ShapesPowerBi  style="position: absolute; bottom: -20px; right: -45px; min-width: 100px; height:100%; z-index:-1;"/>
		<!-- <NuxtImg alt="" style="position: absolute; bottom: -20px; right: -45px; min-width: 100px; height:100%; z-index:-1;" src="/assets/PowerBI_scalable.svg" /> -->
	</v-card>
</template>

<script setup lang="ts">
// No script needed for this component
</script>

<style scoped>
.glass-card {
  /* Usamos variables de Vuetify para que se adapte al tema claro/oscuro */
  background-color: rgba(var(--v-theme-secondary), 0.3);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px); /* Para compatibilidad con Safari */
  border: 1px solid rgba(var(--v-theme-outline-rgb), 0.2);
}

/* .glowing-border {
  border: 1px solid #00E5FF; Color cian para el borde
  box-shadow: 0 0 10px #00E5FF, 0 0 20px #00E5FF, 0 0 30px #00E5FF, inset 0 0 10px #00E5FF;
  transition: all 0.3s ease-in-out;
} */

/* .glowing-border:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 15px #00E5FF, 0 0 30px #00E5FF, 0 0 45px #00E5FF, inset 0 0 15px #00E5FF;
} */
</style>